var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-campaign-source"},[_c('h1',[_vm._v("Start adding gifts from:")]),_c('span',{staticClass:"create-campaign-source__subtext"},[_vm._v("Mix & match from all three")]),_c('create-campaign-source-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }